module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("Notes from Underground")]), _vm._v(" "), _c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("Fyodor Dostoyevsky")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('h2', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("Copyright 2012"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://otbebookpublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("OUTSIDE THE BOX")]), _vm._v(" ebook publishing")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55af9e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/title.vue
// module id = 57
// module chunks = 0